import { generateUniqueId } from "../util";
import { label } from "../../config";

const KEYS = {
  AT: "@",
  HASH: "#",
  TILDE: "~",
  TAB: "Tab",
  SPACE: " ",
  ENTER: "Enter",
  SHIFT: "Shift",
  BACKSPACE: "Backspace",
  BACKTICK: "`",
  DIGIT_2: "2",
  DIGIT_3: "3",
};

/**
 * Function to handle keydown events in the editor's view.
 */
export const handleKeydown = async (
  domEvent, // Dom Events
  setInputPopup,
  insertNonEditable,
  userId,
  setChipTarget,
  prevKey,
  smartChipTarget,
  setTaskSearchPopup,
  overallSearchRef,
  setTempChipId,
  setActiveTab,
  taskKey
) => {
  const { key, shiftKey } = domEvent;

  /* Handle @ symbol after trigger key*/
  if ([KEYS.AT, KEYS.TILDE, KEYS.HASH].includes(key)) {
    domEvent.preventDefault();
    let keyObj = {
      "@": "users",
      "#": "taskId",
      "~": "chips",
    };
    setActiveTab(keyObj[key]);
    return await handleSmartChip(
      insertNonEditable,
      setInputPopup,
      setChipTarget,
      setTempChipId,
      userId,
      key
    );
  }
  
  /* Close popup on Tab or Space*/
  if ([KEYS.TAB, KEYS.SPACE].includes(key)) {
    setInputPopup(false);
  }
  
  /* Update previous key (except for Shift and Backspace)*/
  if (![KEYS.SHIFT, KEYS.BACKSPACE].includes(key)) {
    prevKey.current = key;
  }
  
  /* Close popup if target chip doesn't exist*/
  const isTargetChipExist = document.getElementById(smartChipTarget);
  if (!isTargetChipExist) {
    setInputPopup(false);
  }
  
  return false;
};

/**
 * Handles Smart Chip insertion
 * @param {Function} insertNonEditable - Function to insert non-editable content
 * @param {Function} setInputPopup - Function to set input popup state
 * @param {Function} setChipTarget - Function to set chip target
 * @param {Function} setTempChipId - Function to set temporary chip ID
 * @param {string} userId - User ID
 */
export const handleSmartChip = async (insertNonEditable, setInputPopup, setChipTarget, setTempChipId, userId, keyName) => {
  const id = generateUniqueId(userId);
  setTempChipId(id);
  await insertNonEditable(keyName, id);
  const chipTarget = await document.getElementById(id);
  await setChipTarget(chipTarget);
  setInputPopup(true);
};

/**
 * Handles Task Field mention
 * @param {Function} insertNonEditable - Function to insert non-editable content
 * @param {Function} setTaskSearchPopup - Function to set task search popup state
 * @param {Object} overallSearchRef - Reference to overall search
 * @param {string} userId - User ID
 */
export const handleMentionTask = async (insertNonEditable, setTaskSearchPopup, overallSearchRef, userId, setTempChipId) => {
  const id = generateUniqueId(userId);
  setTempChipId(id);
  await insertNonEditable("#", id);
  const chipTarget = document.getElementById(id);
  overallSearchRef.current = chipTarget;
  setTaskSearchPopup(true);
};
